<template>
	<div class="deliverManage">
		<div class="contentbox">
			<div class="head">
				<div class="label">
					<div class="li" :class="{'active':status==1}" @click="changeStatus(1)"> 
						待邀约面试 
						<div v-if="deliverPending>0" class="unreadCount"></div>
					</div>
					<div class="li" :class="{'active':status==2}" @click="changeStatus(2)"> 面试邀约中 </div>
					<div class="li" :class="{'active':status==3}" @click="changeStatus(3)"> 用户拒绝面试 </div>
					<div class="li" :class="{'active':status==4}" @click="changeStatus(4)"> 等待面试 </div>
					<div class="li" :class="{'active':status==8}" @click="changeStatus(8)"> 面试完成 </div>
					<div class="li" :class="{'active':status==99}" @click="changeStatus(99)"> 忽略简历 </div>
				</div>
			</div>
			
			<div class="deliverRoads" v-loading="loading">
				<div class="noData" v-if="list.length==0">
					<no-Data></no-Data>
				</div>
				
				<div v-for="(item,index) of list" :key="index" class="deliverLi">
					<div class="topbox">
						<div class="left">
							<el-image :src="item.user.avatar" fit="cover" class="userAvatar"></el-image>
							<div class="userInfo">
								<div class="name">
									{{item.user.user_name}}
								</div>
								<div class="text">
									<template v-if="item.user.work_year">{{item.user.work_year}} · </template>
									<template v-if="item.user.ages">{{item.user.ages}}岁 · </template>
									<template v-if="item.user.qualifications">{{item.user.qualifications}}</template>
								</div>
								<div class="phone">
									{{item.user.phone}}
								</div>
							</div>
						</div>
						<div class="center">
							<div class="name">
								{{item.position.position_name}}
							</div>
							<div> {{item.position.address}} </div>
							<div v-if="item.position">
								{{item.position.tag_name_year}} · 
								{{item.position.tag_name_qualifications}} 
								<template v-if="item.position.tag_name_others"> · {{item.position.tag_name_others.split(',')[0]}}</template>
							</div>
						</div>
						<div class="rightbox">
							<el-button size="medium" type="primary" @click="toChat(item)">沟通</el-button>
							<el-button size="medium" v-if="item.status==1&&!item.is_ignore" type="danger" @click="ignoreDeliver(item.id)">忽略</el-button>
							<el-button size="medium" v-if="item.status==1" type="primary" @click="openInvite(item.id)">邀请面试</el-button>
							<el-button size="medium" v-if="item.status==4||item.status==8" type="primary" @click="openDetail(item)">查看详情</el-button>
						</div>
					</div>
					<div v-if="status==3" class="remarks">用户拒绝原因：<span>{{item.remarks}}</span></div>
				</div>
			</div>
		</div>
		
		<el-dialog
			title="面试邀请"
			:visible.sync="inviteShow"
			width="500px">
			<div v-loading="inviteLoading">
				<el-form label-width="80px">
					<el-form-item label="面试日期:">
						<el-date-picker
							style="width: 100%;"
						    v-model="face_at"
						    type="datetime"
							format="yyyy-MM-dd HH:mm"
							value-format="yyyy-MM-dd HH:mm"
							:picker-options="pickerOptions"
						    placeholder="选择日期时间">
						    </el-date-picker>
					</el-form-item>
				</el-form>
				
				<div style="text-align: center;margin-top: 28px;">
					<el-button size="medium" @click="inviteShow = false">取 消</el-button>
					<el-button size="medium" type="primary" @click="sendInvite()">确 定</el-button>
				</div>
			</div>
		</el-dialog>
		
		<el-dialog
			v-if="detail"
			title="面试详情"
			:visible.sync="detailShow"
			width="600px">
			<div class="interviewBox" v-loading="detailLoading">
				<div class="title">
					<span v-if="detail.status==2">面试邀请</span>
					<span v-if="detail.status==3">拒绝面试邀请</span>
					<span v-if="detail.status==4">等待面试</span>
					<span v-if="detail.status==5">面试已取消</span>
					<span v-if="detail.status==6">企业取消面试</span>
					<span v-if="detail.status==7">面试未到</span>
					<span v-if="detail.status==8">面试完成</span>
				</div>
				
				<div class="companybox">
					<el-image class="logo" :src="detail.user.avatar||require('@/static/avatar.png')" fit="cover"></el-image>
					<div class="info">
						<div class="company">{{detail.user.user_name}}</div>
						<div class="user">
							<div class="text">{{detail.user.phone}}</div>
						</div>
					</div>
				</div>
				
				<div class="infbox">
					<div class="title">面试信息</div>
					<div class="box" v-if="detail.face_date">
						<div class="label">时间</div>
						<div class="value">{{detail.face_date}}  {{detail.face_time.substring(0,5)}}</div>
					</div>
					<div class="box">
						<div class="label">职位</div>
						<div class="value">{{detail.position.position_name}} {{detail.position.type==2?detail.position.salary_part_time_job:`${parseFloat((detail.position.salary_min/1000).toFixed(1))}-${parseFloat((detail.position.salary_max/1000).toFixed(1))}k`}}</div>
					</div>
					<div class="box">
						<div class="label">联系人</div>
						<div class="value">{{detail.h_r.user_name}} · {{detail.h_r.phone}}</div>
					</div>
					<div class="box">
						<div class="label">面试地址</div>
						<div class="value">{{detail.company.company_address+detail.company.address_detail}}</div>
					</div>
				</div>
				
				<div class="bottombox" v-if="calcTime()">
					<el-button class="btnsty" type="primary" @click="finishFace()">面试完成</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	export default{
		name:'companyDeliver',
		data(){
			return{
				pickerOptions:{ //禁用当前日期之前的日期
					disabledDate(time) {
						return time.getTime() < Date.now() - 8.64e7 + 24*60*60*1000;
					}
				},	
				loading:false,
				page:1,
				total:0,
				list:[],
				status:1,
				delivery_id:'',
				face_at:'',
				inviteShow:false,
				inviteLoading:false,
				detailShow:false,
				detailLoading:false,
				detail:null,
			}
		},
		computed: {
		    ...mapState(['deliverPending']),
		},
		created() {
			this.getList()
		},
		methods:{
			async toChat(item){
				await this.$store.dispatch('checkoutConversation', {
					conversationID:`C2C${item.user.user_im_account}`,
					position_id:item.position_id
				})
				this.$router.push({ name: 'communication'});
			},
			finishFace(){
				this.$confirm('此操作将设置本次面试已完成，是否继续?', '面试完成', {
					confirmButtonText: '确认完成',
				    cancelButtonText: '取消',
				    type: 'warning'
				}).then(() => {
				    let data = {
				    	delivery_id:this.detail.id,
				    	operator_type:3
				    }
					this.detailLoading = true
					this.$axios.post('/api/client/ES/enInterviewOperator',data).then(res=>{
						this.detailLoading = false
						if(res.code==200){
							this.$eltips(res.msg,'success')
							this.detailShow = false
							this.getList()
						}else{
							this.$eltips(res.msg,'error')
						}
					})
				}).catch(() => {});
			},
			calcTime(){
				let face_at = this.detail.face_at.replace(/\//g, '-')
				let face = new Date(face_at).getTime()
				let now = new Date().getTime()
				if(now>face&&this.detail.status==4){
					return true
				}
				return false
			},
			openDetail(item){
				this.detail = item;
				this.detailShow = true
			},
			sendInvite(){
				if(!this.face_at) return this.$eltips('请选择面试时间','error')
				this.inviteLoading = true
				let data = {
					delivery_id:this.delivery_id,
					face_at:this.face_at
				}
				this.$axios.post('/api/client/ES/invitingInterviews',data).then(res=>{
					this.inviteLoading = false
					if(res.code==200){
						this.$eltips(res.msg,'success')
						this.inviteShow = false
						this.getList()
					}else{
						this.$eltips(res.msg,'error')
					}
				})
			},
			openInvite(id){
				this.delivery_id = id
				this.date = ''
				this.time = ''
				this.inviteShow = true
			},
			ignoreDeliver(id){
				this.$confirm('忽略简历后将不在待邀约列表中出现，是否继续?', '忽略简历', {
				    confirmButtonText: '确定',
				    cancelButtonText: '取消',
				    type: 'warning'
				}).then(() => {
					this.loading = true
				    this.$axios.post('/api/client/ES/ignoreDeliverys',{delivery_id:id}).then(res=>{
						this.loading = false
						if(res.code==200){
							this.$eltips(res.msg,'success')
							this.getList()
						}else{
							this.$eltips(res.msg,'error')
						}
					})
				}).catch(() => {  });

			},
			changeStatus(status){
				if(this.status==status) return;
				this.status = status
				this.page = 1
				this.total = 0
				this.list = []
				this.getList()
			},
			getList(){
				let data = {
					page:this.page,
				}
				if(this.status==1){
					data.is_ignore = 0
				}
				if(this.status==99){
					data.is_ignore=1
					data.status=1
				}else{
					data.status = this.status
				}
				this.loading = true
				this.$axios.get('/api/client/ES/getUserDeliverList',{params:data}).then(res=>{
					this.loading = false
					if(res.code==200){
						this.total = res.data.total
						this.list = res.data.data
						if(this.status==1){
							this.$store.commit('changeDeliverPending', res.data.total)
						}
					}else{
						this.$eltips(res.msg)
					}
				})
			}
		}
	}
</script>

<style>
	.el-picker-panel__footer .el-button--text.el-picker-panel__link-btn {
	    display: none;
	}
</style>
<style lang="scss" scoped>
	
	.deliverManage{
		padding: 24px 0;
		display: flex;
		justify-content: center;
		.page {
			display: flex;
			align-items: center;
			justify-content: center;
			margin: 28px 0 0;
		}
		.contentbox {
			width: 1200px;
			margin: 0 auto;
			position: relative;
			z-index: 2;
			.head {
				display: flex;
				align-items: center;
				margin-bottom: 20px;
				padding: 20px 48px;
				border-radius: 16px;
				background: #FFF;
				.label {
					display: flex;
					align-items: center;
						
					.li {
						color: #151515;
						font-size: 18px;
						font-weight: bold;
						margin-right: 74px;
						cursor: pointer;
						line-height: 1;
						position: relative;
						&:hover {
							color: #51A190;
						}
						.unreadCount {
							width: 7px;
							height: 7px;
							background-color: #FF4444;
							border-radius: 50%;
							position: absolute;
							right: -7px;
							top: -4px;
						}
					}
						
					.active {
						color: #51A190;
						position: relative;
						
						&::after {
							content: '';
							display: block;
							width: 20px;
							height: 4px;
							background-color: #51A190;
							border-radius: 16px;
							bottom: -12px;
							left: 50%;
							position: absolute;
							transform: translate(-50%, 0);
						}
					}
				}
			}
		}
		
		.deliverRoads{
			.noData{
				height: 400px;
				background: #FFF;
				border-radius: 16px;
			}
			.deliverLi{
				margin-bottom: 20px;
				padding:18px 28px;
				border-radius: 16px;
				background-color: #FFFF;
				.topbox{
					display: flex;
					align-items: center;
					justify-content: space-between;
				}
				.remarks{
					margin-top: 18px;
					font-size: 14px;
					span{
						color: #F44;
					}
				}
				.left{
					display: flex;
					align-items: center;
					flex: 0 0 260px;
					margin-right: 120px;
					.userAvatar{
						width: 80px;
						height: 80px;
						border-radius: 50%;
						margin-right: 16px;
					}
					.userInfo{
						height: 80px;
						display: flex;
						justify-content: space-between;
						flex-direction: column;
						.name{
							font-size: 16px;
							font-weight: bold;
						}
					}
				}
				.center{
					flex: 1;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					height: 80px;
					.name{
						font-size: 20px;
						font-weight: bold;
					}
				}
				.rightbox{
					flex: 0 0 270px;
					text-align: right;
				}
			}
		}
	}
	
	.interviewBox{
		.title{
			font-weight: bold;
			font-size: 20px;
		}
		.companybox{
			background: #FFFFFF;
			padding: 18px 0;
			display: flex;
			border-radius: 14px;
			margin-top: 12px;
			.logo{
				flex: 0 0 54px;
				width: 54px;
				height: 54px;
				margin-right: 12px;
				border-radius: 4rpx;
				border-radius: 50%;
			}
			.info{
				.company{
					font-size: 16rpx;
					font-weight: bold;
				}
				.user{
					display: flex;
					align-items: center;
					margin-top: 8px;
					.avatar{
						width: 32px;
						height: 32px;
						margin-right: 8px;
					}
					.text{
						font-size: 14px;
					}
				}
			}
		}
		
		.infbox{
			margin-top: 18px;
			border-radius: 14px;
			background: #FFF;
			.title{
				font-size: 16px;
				font-weight: bold;
				line-height: 1;
				margin-bottom: 16px;
			}
			.box{
				display: flex;
				margin-top: 14px;
				.label{
					flex: 0 0 120px;
					font-size: 14px;
				}
				.value{
					font-size: 14px;
				}
			}
		}
		
		.bottombox{
			margin-top: 32px;
			display: flex;
			align-items: center;
			.btnsty{
				flex: 1;
				text-align: center;
				border-radius: 8px;
				margin-right: 14px;
				&:last-child{
					margin-right: 0;
				}
			}
			.fail{
				flex: .5;
			}
		}
	}
</style>